const PERIOD_PATTERN = /^(\d{4})-?(\d{2})$/;

export function formatTimePeriod(timePeriod: string): string {
  const periodMatch = PERIOD_PATTERN.exec(timePeriod.trim());
  if (periodMatch == null) return timePeriod;

  const [, year, month] = periodMatch;
  const parsedMonth = Number(month);
  if (parsedMonth < 1 || parsedMonth > 12) return timePeriod;

  return `${year}-${month}`;
}
